/**
 * Andrade — política de estoque: tudo é fabricável, nunca "Esgotado" na vitrine/PDP.
 * Pronta entrega (metafield custom.pronta_entrega): FULL com estoque; prazo de fabricação sem estoque.
 */
(function (global) {
  'use strict';

  /**
   * @param {HTMLElement | null} meta
   * @param {{ available?: boolean } | null | undefined} variant
   * @returns {{ text: string, inStockGreen: boolean, isProduction: boolean }}
   */
  function stockMetaDisplay(meta, variant) {
    if (!meta) return { text: '', inStockGreen: false, isProduction: false };

    var available = !variant || variant.available !== false;

    if (meta.hasAttribute('data-production-full') && available) {
      return {
        text: meta.dataset.fullTag || '',
        inStockGreen: true,
        isProduction: false,
      };
    }

    if (meta.hasAttribute('data-md-production')) {
      return {
        text: meta.dataset.productionText || '',
        inStockGreen: false,
        isProduction: true,
      };
    }

    return {
      text: meta.dataset.fallbackInStock || '',
      inStockGreen: available,
      isProduction: false,
    };
  }

  /**
   * @param {HTMLElement | null} meta
   * @param {{ available?: boolean } | null | undefined} variant
   */
  function applyStockMeta(meta, variant) {
    if (!meta) return;
    var display = stockMetaDisplay(meta, variant);
    meta.textContent = display.text;
    meta.classList.toggle('md-pdp__meta--in-stock', display.inStockGreen);
    meta.classList.toggle('md-pdp__meta-production', display.isProduction);
  }

  var SOLD_OUT_COPY =
    /esgotou|esgotad|sold\s*out|out of stock|não está disponível|nao esta disponivel|is not available|cannot be sold|can't be sold/i;

  /**
   * @param {string} [message]
   * @param {string} [description]
   * @param {string} [fallback]
   * @returns {string}
   */
  function sanitizeCartError(message, description, fallback) {
    var raw = [description, message].filter(Boolean).join(' ');
    var fb =
      fallback ||
      'Não foi possível concluir a compra. Tente novamente ou fale conosco pelo WhatsApp.';
    if (SOLD_OUT_COPY.test(raw) || SOLD_OUT_COPY.test(String(description || '')) || SOLD_OUT_COPY.test(String(message || ''))) {
      return fb;
    }
    return String(description || message || fb);
  }

  global.AndradeInventoryPolicy = {
    alwaysPurchasable: true,
    stockMetaDisplay: stockMetaDisplay,
    applyStockMeta: applyStockMeta,
    isSoldOutCopy: function (text) {
      return SOLD_OUT_COPY.test(String(text || ''));
    },
    sanitizeCartError: sanitizeCartError,
  };
})(window);
